import { atom, DefaultValue, selectorFamily } from "recoil";
import {ICompany, IGetCarsAvailabilitiesParams, IRangeDate} from "../../api/services";
import { AccordionsExpanded } from "./types";

export const editAccordionsExpandedState = atom<AccordionsExpanded>({
    key: 'editAccordionsExpandedState',
    default: {
        extraServices: false,
        total: true,
        bookingOwner: false,
        invoice: false,
        firstDriver: false,
        additionalDrivers: false
    },
});

export const editAccordionExpandedState = selectorFamily<boolean, keyof AccordionsExpanded>({
    key: 'editAccordionExpandedState',
    get: accordionName => ({ get }) => get(editAccordionsExpandedState)[accordionName],
    set: accordionName => ({ get, set }, newValue) => {
        set(editAccordionsExpandedState, {
            ...get(editAccordionsExpandedState),
            [accordionName]: newValue instanceof DefaultValue ? false : newValue
        })
    }
});

export const editTotalRentalDaysState = atom<number>({
    key: 'editTotalRentalDaysState',
    default: 0
});

export const editCarsAvailabilitiesParamsState = atom<IGetCarsAvailabilitiesParams | undefined>({
    key: 'editCarsAvailabilitiesParamsState',
    default: undefined
});

export const editCustomerBillingDataB2B = atom<ICompany | undefined>({
    key: 'editCustomerBillingDataB2B',
    default: undefined
});
export const recalculationTotalToBePaid = atom<boolean>({
    key: 'recalculationTotalToBePaid',
    default: false
});

export const editBusinessAgreementCheckValidate = atom<boolean | undefined>({
    key: 'editBusinessAgreementCheckValidate',
    default: undefined
});

export const editBusinessAgreementCig = atom<boolean | undefined>({
    key: 'editBusinessAgreementCig',
    default: undefined
});

export const editMandatoryDossierIsRequired = atom<boolean | undefined>({
    key: 'editMandatoryDossierIsRequired',
    default: undefined
});

export const editRangeDateValidity = atom<IRangeDate | undefined>({
    key: 'editRangeDateValidity',
    default: undefined
});

export const idSmProductDefaultByEditState = atom<string | null>({
    key: 'idSmProductDefaultByEditState',
    default: undefined
});

export const originalDiscountOverprice = atom<number | null>({
    key: 'originalDiscountOverprice',
    default: null
});

export const editRatePlanOfferIDState = atom<string | undefined>({
    key: 'editRatePlanOfferIDState',
    default: undefined
});

export const editIsPersonBAState = atom<boolean>({
    key: 'editIsPersonBAState',
    default: false
})

export const editPendingBookingRce = atom<boolean>({
    key: 'editPendingBookingRce',
    default: false
})